var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedFeatureShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1441,
    height: 241,
    fill: "none",
    viewBox: "0 0 1441 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7CACA",
    d: "M.81.4l332.825 111.497L706.91 77.964l344.19 33.933L1440.81.401V240.97H.81V.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFeatureShape);
export default __webpack_public_path__ + "static/media/redFeatureShape.0eb3c79e97569acc4248d9ea3b48518f.svg";
export { ForwardRef as ReactComponent };